define([
  "marionette",
  "jquery",
  "underscore",
  "select2",
  "messaging/messenger",
  "configuration/properties",
  "modules/tasks/tasksModel",
  "./template/taskWizardModalTemplate.html",
], function (Marionette, $, _, select2, Messenger, Properties, TaskModel, TaskWizardModalTemplate) {
  "use strict";

  var TaskWizardModalView = {};

  TaskWizardModalView.view = Marionette.Layout.extend({
    template: TaskWizardModalTemplate,
    regions: {
      wizardPage: ".task-wizard-page",
    },
    triggers: {
      "click .back-button": "back",
      "click .cancel-button": "cancel",
      "click .done-button": "done",
      "click .next-button": "next",
    },
    hideButtons: function () {
      $(".back-button", this.$el).addClass("hidden");
      $(".done-button", this.$el).addClass("hidden");
      $(".next-button", this.$el).addClass("hidden");
    },
    showBackButton: function () {
      $(".back-button", this.$el).removeClass("hidden");
    },
    showDoneButton: function () {
      $(".done-button", this.$el).removeClass("hidden");
    },
    showNextButton: function () {
      $(".next-button", this.$el).removeClass("hidden");
    },
  });

  return TaskWizardModalView;
});
